module.exports = __webpack_public_path__ + "media/images/platforms/steam/background-48be7b3ff4c3c554235f4c6723ff981b.jpg";